import styled from 'styled-components';
import zigzag from '../../images/zig zag.png'

export const InfoContainer = styled.div`
  color: #fff;
  background: ${({lightBg}) => (lightBg ? '#f0f0fe' : '#f0f0fe')};

  @media screen and  (max-width: 768px) {
    padding-right: 30px;
      padding-left: 30px;
  }
`
export const InfoWrapper = styled.div`
  display: flex;
  z-index: 1;
  min-height: 420px;
  padding-top : 30px;
  width: 100%auto;
  max-width: 1100px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 30px;
  padding: 0 24px;
  justify-content: center;
`
export const InfoRow = styled.div`
  // display: grid;
  // grid-auto-columns: minmax(auto, 1fr);
  // align-items: center;
  // grid-template-areas: ${({imgStart}) => (imgStart ? `'col2 col1'` : `'col1 col2'`)};

  // @media screen and (max-width: 768px) {
  //   grid-template-areas: ${({imgStart}) => (imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`)}
  // }
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
    flex-direction: column; 
    font-size: 12px;
  }
    
`
export const Column1 = styled.div`
  margin-bottom: 15px;
  margin-top: 180px;
  padding: 0 5px;
  // grid-area: col1;
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  @media screen and (max-width: 768px) {
    justify-content: center;
    align-items: center;
  }
`
export const Column2 = styled.div`
margin-bottom: 15px;
margin-top: 180px;
padding: 0 5px;
// grid-area: col1;
display: flex;
flex-direction: row;
// background: blue;

margin-top: 15px;
@media screen and (max-width: 768px) {
  justify-content: center;
  align-items: center;
  width: 50%;
}
`
export const TextWrapper = styled.div`
  // max-width: 540px;
  padding-top: 10px;
  // padding-bottom: 60px;
  padding-left: 10px;
  font-size: 28px;
  width: 80%
  
`
export const TopLine = styled.div`
  color: #01bf71;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  // letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
  margin-top: 16px;
  background-image: url(${zigzag});
  background-size: contain !important;
  background-repeat: no-repeat;
  @media screen and (max-width: 768px) {
    flex-direction: column; 
    font-size: 12px;
  }
  
`
export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600px;
  color: ${({lightText}) => (lightText ? '#f7f8fa' : '#010606')};

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`
export const Subtitle  = styled.p`
  max-width: 440px;
  margin-bottom: 35px;
  font-size: 15px;
  line-height: 24px;
  color: #010606;
`
export const BtnWrap = styled.div`
  display:flex;
  justify-content: flex-start;
`;
export const ImgWrap = styled.div`
  max-width: 555px;
  height: 100%;
`;
export const Img = styled.img`
  width: 100%;
  margin: 0 0 10px 0;
  padding-right: 0;
`;
